export default __webpack_public_path__ + "static/media/Cs.7f58ab59.png";